import { ReviewRatingsProps } from 'components/review-ratings/types'
import { ReactNode } from 'react'
import { BiLingualValue } from 'types/common'
import GoogleReviews from 'components/review-ratings/assets/GoogleReviews'
import { RatingSvgProps } from 'components/review-ratings/assets/types'
import Vnr from 'components/review-ratings/assets/Vnr'
import Trustpilot from 'components/review-ratings/assets/Trustpilot'

export const RATING_INSTANCES = ['googleReviews', 'vnr', 'trustpilot'] as const
export type RatingInstance = (typeof RATING_INSTANCES)[number]

export const DEFAULT_RATINGS: ReviewRatingsProps['show'] = {
  vnr: true,
  googleReviews: true
}

type Review = {
  logo?: (props: RatingSvgProps) => ReactNode
  score: number
  label: BiLingualValue<string>
}
export const REVIEWS: Record<RatingInstance, Review> = {
  googleReviews: {
    logo: (props) => <GoogleReviews {...props} />,
    score: 4,
    label: {
      nl: 'op Google Reviews',
      fr: 'sur Google Reviews'
    }
  },
  vnr: {
    logo: (props) => <Vnr {...props} />,
    score: 5,
    label: {
      nl: 'op de V-test',
      fr: 'au V-test'
    }
  },
  trustpilot: {
    logo: (props) => <Trustpilot {...props} />,
    score: 4.3,
    label: {
      nl: 'op Trustpilot',
      fr: 'sur Trustpilot'
    }
  }
}
